export default [
  {
    path: '/guide',
    component: () => import('@/views/guide/guide.vue'),
    name: 'guide',
    meta: {
      auth: 0,
      title: '息屏导航引导',
    },
  },
  {
    path: '/ready',
    component: () => import('@/views/guide/ready.vue'),
    name: 'ready',
    meta: {
      title: '强制READY',
      backgroundClass: 'bg-gray',
    },
  },
  // 密码解锁使用教程
  {
    path: '/guide-passwordUnlock',
    component: () => import('@/views/guide/PasswordUnlock.vue'),
    name: 'guide-passwordUnlock',
    meta: {
      title: '帮助',
      backgroundClass: 'bg-gray',
      hideNaginationBar: false,
    },
  },
  {
    path: '/guide-nfcGuide',
    component: () => import('@/views/guide/NfcGuide.vue'),
    name: 'nfcGuide',
    meta: {
      auth: 0,
      title: 'NFC 钥匙管理',
      backgroundClass: 'bg-gray',
      hideNaginationBar: false,
    },
  },
];
